(function () {
  'use strict';

  var ADD_SELECTOR = '[data-bv-minicart-product-upsell-add]';
  var VARIANT_SELECTOR = '[data-bv-minicart-product-upsell-variant]';
  var PRICE_SELECTOR = '[data-bv-minicart-product-upsell-price]';
  var IMAGE_SELECTOR = '[data-bv-minicart-product-upsell-image]';
  var ROOT_SELECTOR = '[data-bv-minicart-product-upsell]';
  var CAROUSEL_SELECTOR = '[data-bv-minicart-product-upsell-carousel]';
  var TRACK_SELECTOR = '[data-bv-minicart-product-upsell-track]';
  var CARD_SELECTOR = '[data-bv-minicart-product-upsell-card]';
  var PREV_SELECTOR = '[data-bv-minicart-product-upsell-prev]';
  var NEXT_SELECTOR = '[data-bv-minicart-product-upsell-next]';
  var CART_CONTENT_SELECTOR = '[data-ajax-cart-content]';
  var DETAILS_WRAPPER_SELECTOR = '.ajax-cart__details-wrapper';
  var CART_BLOCK_SELECTOR = '.ajax-cart__details-wrapper .cart__block-bg';

  function refreshMiniCart() {
    if (
      window.Shopify &&
      Shopify.theme &&
      Shopify.theme.jsAjaxCart &&
      typeof Shopify.theme.jsAjaxCart.updateView === 'function'
    ) {
      Shopify.theme.jsAjaxCart.updateView();
    }
  }

  function setButtonLabel(button, label, disabled) {
    button.textContent = label;
    button.disabled = Boolean(disabled);
  }

  function addVariant(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalLabel = button.getAttribute('data-label') || button.textContent;
    setButtonLabel(button, 'Adding…', true);

    fetch(window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(variantId),
        quantity: 1
      })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (error) {
            throw error;
          });
        }
        return response.json();
      })
      .then(function () {
        setButtonLabel(button, 'Added', true);
        refreshMiniCart();
        window.setTimeout(function () {
          setButtonLabel(button, originalLabel, false);
        }, 900);
      })
      .catch(function () {
        setButtonLabel(button, originalLabel, false);
      });
  }

  function getCarouselState(root) {
    return {
      root: root,
      track: root.querySelector(TRACK_SELECTOR),
      cards: root.querySelectorAll(CARD_SELECTOR),
      prev: root.querySelector(PREV_SELECTOR),
      next: root.querySelector(NEXT_SELECTOR),
      index: 0
    };
  }

  function updateNav(state) {
    if (state.prev) state.prev.disabled = state.index <= 0;
    if (state.next) state.next.disabled = state.index >= state.cards.length - 1;
  }

  function goTo(state, nextIndex, animate) {
    if (!state.track || !state.cards.length) return;
    state.index = Math.max(0, Math.min(state.cards.length - 1, nextIndex));
    state.track.style.transition = animate === false ? 'none' : '';
    state.track.style.transform = 'translateX(-' + state.index * 100 + '%)';
    updateNav(state);
  }

  function initCarousel(root) {
    if (!root || root.dataset.bvCarouselReady === 'true') return;

    var state = getCarouselState(root);
    if (!state.track || state.cards.length < 2) return;

    root.dataset.bvCarouselReady = 'true';
    root._bvCarouselState = state;
    goTo(state, 0, false);
  }

  function initAllCarousels() {
    document.querySelectorAll(CAROUSEL_SELECTOR).forEach(initCarousel);
  }

  function getAjaxCartContent(callback) {
    if (
      !window.Shopify ||
      !Shopify.theme ||
      !Shopify.theme.asyncView ||
      typeof Shopify.theme.asyncView.load !== 'function'
    ) {
      return;
    }

    Shopify.theme.asyncView.load('/cart', 'ajax').done(function (response) {
      if (!response || !response.html || !response.html.content) return;
      callback(response.html.content);
    });
  }

  function updateUpsellMarkup(content) {
    var parser = document.createElement('div');
    parser.innerHTML = content;

    var nextUpsell = parser.querySelector(ROOT_SELECTOR);
    var currentUpsell = document.querySelector(ROOT_SELECTOR);

    if (currentUpsell) {
      if (nextUpsell) {
        currentUpsell.replaceWith(nextUpsell);
      } else {
        currentUpsell.remove();
      }

      initAllCarousels();
      return;
    }

    if (!nextUpsell) return;

    var cartBlock = document.querySelector(CART_BLOCK_SELECTOR);
    if (cartBlock && cartBlock.parentNode) {
      cartBlock.parentNode.insertBefore(nextUpsell, cartBlock);
    } else {
      var detailsWrapper = document.querySelector(DETAILS_WRAPPER_SELECTOR);
      if (detailsWrapper) {
        detailsWrapper.insertBefore(nextUpsell, detailsWrapper.firstChild);
      }
    }

    initAllCarousels();
  }

  function syncUpsellMarkup() {
    getAjaxCartContent(updateUpsellMarkup);
  }

  function patchAjaxCartUpdateView() {
    if (
      !window.Shopify ||
      !Shopify.theme ||
      !Shopify.theme.jsAjaxCart ||
      typeof Shopify.theme.jsAjaxCart.updateView !== 'function' ||
      Shopify.theme.jsAjaxCart.updateView._bvMinicartProductUpsellPatched
    ) {
      return;
    }

    var originalUpdateView = Shopify.theme.jsAjaxCart.updateView;

    Shopify.theme.jsAjaxCart.updateView = function () {
      var response = originalUpdateView.apply(this, arguments);

      window.setTimeout(syncUpsellMarkup, 150);
      return response;
    };

    Shopify.theme.jsAjaxCart.updateView._bvMinicartProductUpsellPatched = true;
  }

  var drag = {
    active: false,
    state: null,
    startX: 0,
    deltaX: 0
  };

  function clientX(event) {
    return event.touches ? event.touches[0].clientX : event.clientX;
  }

  document.addEventListener('click', function (event) {
    var prev = event.target.closest(PREV_SELECTOR);
    if (prev) {
      var prevRoot = prev.closest(CAROUSEL_SELECTOR);
      if (prevRoot && prevRoot._bvCarouselState) {
        event.preventDefault();
        goTo(prevRoot._bvCarouselState, prevRoot._bvCarouselState.index - 1);
      }
      return;
    }

    var next = event.target.closest(NEXT_SELECTOR);
    if (next) {
      var nextRoot = next.closest(CAROUSEL_SELECTOR);
      if (nextRoot && nextRoot._bvCarouselState) {
        event.preventDefault();
        goTo(nextRoot._bvCarouselState, nextRoot._bvCarouselState.index + 1);
      }
      return;
    }

    var button = event.target.closest(ADD_SELECTOR);
    if (!button || !button.closest(ROOT_SELECTOR)) return;
    event.preventDefault();
    if (button.disabled) return;
    addVariant(button);
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest(VARIANT_SELECTOR);
    if (!input || !input.closest(ROOT_SELECTOR)) return;
    if (input.type !== 'radio' || !input.checked) return;

    var card = input.closest(CARD_SELECTOR) || input.closest(ROOT_SELECTOR);
    var button = card.querySelector(ADD_SELECTOR);
    var price = card.querySelector(PRICE_SELECTOR);
    var image = card.querySelector(IMAGE_SELECTOR);

    if (button) {
      button.setAttribute('data-variant-id', input.value);
    }

    if (price && input.getAttribute('data-price')) {
      price.textContent = input.getAttribute('data-price');
    }

    if (image && input.getAttribute('data-image')) {
      image.setAttribute('src', input.getAttribute('data-image'));

      if (input.getAttribute('data-image-alt')) {
        image.setAttribute('alt', input.getAttribute('data-image-alt'));
      }
    }
  });

  document.addEventListener('mousedown', function (event) {
    var track = event.target.closest(TRACK_SELECTOR);
    if (!track) return;
    if (event.target.closest('button, select, a, label, input, fieldset')) return;
    var root = track.closest(CAROUSEL_SELECTOR);
    if (!root || !root._bvCarouselState) return;

    drag.active = true;
    drag.state = root._bvCarouselState;
    drag.startX = clientX(event);
    drag.deltaX = 0;
    track.classList.add('is-dragging');
  });

  document.addEventListener('touchstart', function (event) {
    var track = event.target.closest(TRACK_SELECTOR);
    if (!track) return;
    if (event.target.closest('button, select, a, label, input, fieldset')) return;
    var root = track.closest(CAROUSEL_SELECTOR);
    if (!root || !root._bvCarouselState) return;

    drag.active = true;
    drag.state = root._bvCarouselState;
    drag.startX = clientX(event);
    drag.deltaX = 0;
    track.classList.add('is-dragging');
  }, { passive: true });

  window.addEventListener('mousemove', function (event) {
    if (!drag.active || !drag.state || !drag.state.track) return;
    drag.deltaX = clientX(event) - drag.startX;
    var width = drag.state.track.offsetWidth || 1;
    var percent = (drag.deltaX / width) * 100;
    drag.state.track.style.transition = 'none';
    drag.state.track.style.transform =
      'translateX(calc(-' + drag.state.index * 100 + '% + ' + percent + '%))';
  });

  window.addEventListener('touchmove', function (event) {
    if (!drag.active || !drag.state || !drag.state.track) return;
    drag.deltaX = clientX(event) - drag.startX;
    var width = drag.state.track.offsetWidth || 1;
    var percent = (drag.deltaX / width) * 100;
    drag.state.track.style.transition = 'none';
    drag.state.track.style.transform =
      'translateX(calc(-' + drag.state.index * 100 + '% + ' + percent + '%))';
  }, { passive: true });

  function endDrag() {
    if (!drag.active || !drag.state || !drag.state.track) {
      drag.active = false;
      drag.state = null;
      return;
    }

    drag.state.track.classList.remove('is-dragging');
    var threshold = (drag.state.track.offsetWidth || 1) * 0.2;
    if (Math.abs(drag.deltaX) > threshold) {
      goTo(drag.state, drag.state.index + (drag.deltaX < 0 ? 1 : -1));
    } else {
      goTo(drag.state, drag.state.index);
    }

    drag.active = false;
    drag.state = null;
    drag.deltaX = 0;
  }

  window.addEventListener('mouseup', endDrag);
  window.addEventListener('touchend', endDrag);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchAjaxCartUpdateView();
      initAllCarousels();
    });
  } else {
    patchAjaxCartUpdateView();
    initAllCarousels();
  }

  window.setTimeout(patchAjaxCartUpdateView, 500);

  var cartContent = document.querySelector(CART_CONTENT_SELECTOR);
  if (cartContent && window.MutationObserver) {
    var observer = new MutationObserver(function () {
      window.setTimeout(initAllCarousels, 50);
    });
    observer.observe(cartContent, { childList: true, subtree: true });
  }
})();
